<template>
    <TooltipProvider>
        <Tooltip>
            <TooltipTrigger as-child>
                <div class="relative">
                    <Button
                        variant="tertiary"
                        icon
                        as-child
                        :aria-label="t('NOTIFICATIONS')"
                    >
                        <router-link to="/notifications">
                            <BellIcon />
                        </router-link>
                    </Button>
                    <span
                        v-if="notifications > 0"
                        class="absolute flex justify-center size-6 font-bold text-white rounded-full items-center bg-red-500 -top-2 -right-2 select-none"
                        :class="{
                            'text-[10px]': hasManyNotifications,
                            'text-[12px]': !hasManyNotifications,
                        }"
                    >
                        {{ hasManyNotifications ? '99+' : notifications }}
                    </span>
                </div>
            </TooltipTrigger>
            <TooltipContent>{{ t('NOTIFICATIONS') }}</TooltipContent>
        </Tooltip>
    </TooltipProvider>
</template>

<script lang="ts" setup>
    import Button from '@/shared/ui/Button/Button.vue';
    import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/shared/ui/Tooltip';

    import notificationService from '@/services/notification.service';
    import { BellIcon } from '@heroicons/vue/24/solid';

    const { t } = useI18n();

    const notifications = ref<number>(0);

    const refreshNotifications = async () => {
        notifications.value = await notificationService.getTotalNotifications();
    };

    const hasManyNotifications = computed(() => notifications.value > 99);

    onBeforeMount(() => {
        refreshNotifications();
    });
</script>

<i18n lang="yaml">
en:
    NOTIFICATIONS: Notifications
nl:
    NOTIFICATIONS: Meldingen
</i18n>
